import { geoCodeAddressFromDataGouv } from './geoCodeAddressFromDataGouv';

export const DataGouvService = {
  geoCodeAddressFromDataGouv,
};
